import { RESULT_STATUS_COLORS } from "../../utils/reportcard/reportCardHelpers";

export default function ResultStatusBadge({ status }) {
  if (!status) return null;
  return (
    <span
      className={`inline-flex text-[11px] font-semibold px-2 py-0.5 rounded-full ${ RESULT_STATUS_COLORS[status] || "bg-gray-100 dark:bg-neutral-900 text-gray-700 dark:text-neutral-200" }`}
    >
      {status}
    </span>
  );
}
